import styled from "styled-components";

export const AdvancedTabsContainer = styled.div`
  background-color: #fbfbfa;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
